/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AccessSecret/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AccessSecret({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Created/AccessSecret"
  
}) {
let createTokenCreatedSecretValueData = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'created_secret',
})
let createTokenCreatedSecretValueData1 = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'created_secret',
})
let createTokenCreatedSecretValueData2 = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'created_secret',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 disabled={true}
 data="create_token.created_secret"
 value={createTokenCreatedSecretValueData}
>
{childProps => (
<React.Fragment>
<div
  data-testid="AccessSecret.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Access Secret"
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 marginTop={-4}
 data="create_token.created_secret"
 value={createTokenCreatedSecretValueData1}
 data="create_token.created_secret"
 text={createTokenCreatedSecretValueData2}
/>
</div>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}